module.exports = __webpack_public_path__ + "static/media/cantract-min.ba48e9b0.jpg";